/**
 * @generated SignedSource<<b7d27eff907af4b0623d7f5360b2f310>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CopyPopupSetInput = {
  clientMutationId?: string | null;
  popupSetId: string;
};
export type PopupSetTableActions_CopyMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CopyPopupSetInput;
};
export type PopupSetTableActions_CopyMutationVariables = PopupSetTableActions_CopyMutation$variables;
export type PopupSetTableActions_CopyMutation$data = {
  readonly copyPopupSet: {
    readonly popupSetEdge: {
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly memo: string | null;
      } | null;
    };
  } | null;
};
export type PopupSetTableActions_CopyMutationResponse = PopupSetTableActions_CopyMutation$data;
export type PopupSetTableActions_CopyMutation = {
  variables: PopupSetTableActions_CopyMutationVariables;
  response: PopupSetTableActions_CopyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PopupSetEdge",
  "kind": "LinkedField",
  "name": "popupSetEdge",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PopupSet",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "memo",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupSetTableActions_CopyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CopyPopupSetPayload",
        "kind": "LinkedField",
        "name": "copyPopupSet",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupSetTableActions_CopyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CopyPopupSetPayload",
        "kind": "LinkedField",
        "name": "copyPopupSet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "popupSetEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "44cbb8b95feeb0e216243564df23d14f",
    "id": null,
    "metadata": {},
    "name": "PopupSetTableActions_CopyMutation",
    "operationKind": "mutation",
    "text": "mutation PopupSetTableActions_CopyMutation(\n  $input: CopyPopupSetInput!\n) {\n  copyPopupSet(input: $input) {\n    popupSetEdge {\n      node {\n        id\n        name\n        memo\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2327e4c38ea55d23cf0879d462265b88";

export default node;
